import { createContext } from 'react';
export interface ApiServerConfiguration {
  defaultRedirectUrl: string;
  apiRootUrl?: string;
}
export const ApiServerConfigurationContext = createContext<ApiServerConfiguration>({ defaultRedirectUrl: 'dashboard.tradingblock.com', apiRootUrl: undefined });
